import React, { useEffect, useState } from 'react';
import { Box, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import 'react-nice-dates/build/style.css';
import { RedeemLabel } from '../../../components/Status/StatusLabel';
import {
   faHistory,
   faMinusCircle,
   faPlusCircle,
} from '@fortawesome/pro-duotone-svg-icons';
import Increase from '../../../components/Modal/StockManagement/Increase';
import View from '../../../components/Modal/StockManagement/View';
import Decrease from '../../../components/Modal/StockManagement/Decrease';
import IncreaseCode from '../../../components/Modal/StockManagement/IncreaseCode';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      // display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function StockManagement(props) {
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   useEffect(() => {
      getData(null);
   }, []);
   const getData = (value) => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/reward/GetStockList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            if (sessionStorage['value']) sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
                  data: value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };
   const refreshData = () => {
      setShowModal(false);
      setData([]);
      getData();
   };
   const setModalStyle = (type, value) => {
      if (type === 'view') {
         setMyModal(
            <View
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'increase-raas') {
         setMyModal(
            <Increase
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'increase-code') {
         setMyModal(
            <IncreaseCode
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'decrease') {
         setMyModal(
            <Decrease
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>เรียกดูของรางวัลคงเหลือ</Typography>
            </Box>
         </Box>
         <Box>
            <MaterialTable
               isLoading={isLoading}
               columns={[
                  {
                     field: 'stockModeDesc',
                     title: 'รูปแบบคลังสินค้า',
                     sorting: false,
                     export: false,
                     render: (rowData) => (
                        <RedeemLabel
                           StatusType={rowData.stockMode}
                           msg={
                              rowData.stockMode === 1
                                 ? 'Physical'
                                 : 'Code/Serial'
                           }
                        />
                     ),
                  },
                  {
                     field: 'rewardRef',
                     title: 'รหัสอ้างอิงการแลก',
                  },
                  {
                     field: 'name',
                     title: 'ชื่อ',
                     render: (rowData) =>
                        `${rowData.nameTh} | ${rowData.nameEn}`,
                  },
                  {
                     field: 'total',
                     title: 'จำนวนทั้งหมด',
                     type: 'numeric',
                  },
                  {
                     field: 'qty',
                     title: 'จำนวนคงเหลือ',
                     type: 'numeric',
                  },
                  {
                     field: 'reserveQty',
                     title: 'จำนวนการจอง',
                     type: 'numeric',
                  },
                  {
                     field: 'updatedTime',
                     title: 'เวลาปรับปรุงล่าสุด',
                     type: 'numeric',
                     render: (rowData) =>
                        dayjs(new Date(rowData.updatedTime)).format(
                           'DD/MM/BBBB  HH:mm',
                        ),
                  },
               ]}
               data={data}
               options={{
                  showTitle: false,
                  headerStyle: headerStyle,
                  padding: 'dense',
                  actionsColumnIndex: -1,
                  actionsCellStyle: {
                     color: '#ccc',
                  },
                  addRowPosition: 'first',
                  pageSize: 5,
                  pageSizeOptions: [5, 10, 25, 50, 100],
               }}
               localization={{
                  header: { actions: 'ตัวจัดการ' },
               }}
               style={tableStyle}
               actions={[
                  {
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={faRedoAlt}
                           size={'xs'}
                        />
                     )),
                     tooltip: 'Refresh Data',
                     isFreeAction: true,
                     onClick: () => refreshData(),
                  },
                  (rowData) => ({
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={faHistory}
                           color='#00a2e8'
                        />
                     )),
                     tooltip: 'ประวัติ',
                     onClick: (event, rowData) =>
                        setModalStyle('view', rowData),
                  }),
                  (rowData) => ({
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           color={'#22b14c'}
                           icon={faPlusCircle}
                        />
                     )),
                     tooltip: 'เพิ่ม',
                     onClick: (event, rowData) => {
                        setModalStyle(
                           rowData.stockMode === 1
                              ? 'increase-raas'
                              : 'increase-code',
                           rowData.data,
                        );
                     },
                  }),
                  (rowData) => {
                     if (rowData.stockMode === 1) {
                        return {
                           icon: React.forwardRef((props, ref) => (
                              <FontAwesomeIcon
                                 ref={ref}
                                 {...props}
                                 color={'#ff7f27'}
                                 icon={faMinusCircle}
                              />
                           )),
                           tooltip: 'ลด',
                           onClick: (event, rowData) => {
                              setModalStyle('decrease', rowData.data);
                           },
                        };
                     }
                  },
               ]}
               icons={tableIcons}
            />
         </Box>
      </Paper>
   );
}

export default StockManagement;
